import React from 'react';
import Button, { ButtonProps } from '../Button';
import Stack, { contentStackSpacing } from '../Stack';

export type PromptActionButtonProps = Omit<ButtonProps, 'size'> & {
    show?: boolean;
} & { title: string };

export type PromptActionsOwnProps = {
    actions?: PromptActionButtonProps[];
};

export type PromptActionsProps = PromptActionsOwnProps;

const PromptActions: React.FC<PromptActionsProps> = (props) => {
    if (!props.actions?.length) return null;

    return (
        <Stack
            fullWidth
            vertical
            align="center"
            space={contentStackSpacing}
            style={{
                marginTop: 20,
            }}
        >
            {props.actions
                .filter((_) => _.show !== false)
                .map(({ ...action }, index) => (
                    <Button {...action} key={index} size="lg" />
                ))}
        </Stack>
    );
};

export default React.memo(PromptActions);
